module.exports = __webpack_public_path__ + "img/ee4b2b8.png";